<template>
  <div class="about-us">
    <div class="header"></div>
    <div class="main">
      <div class="title-container">
        <p class="main-title">协会简介</p>
        <el-button type="primary" class="join-association-btn" @click="goToJoin">加入协会</el-button>
      </div>
      <p class="main-content">
        四川省再生资源行业协会（以下简称协会）成立于1993年，协会经民政厅核准成立，接受四川省供销合作社联合社的业务指导与监督管理。协会由从事再生资源回收加工利用生产的相关企业、事业单位、社会团体、科研机构等相关组织与专家、学者自愿参加组成的，具有社团法人资格的地方性、专业性、非营利性的再生资源行业社会组织。
      </p>
      <p class="main-content">
        随着生态环境保护与可持续发展理念日益深入人心，再生资源回收利用在国家发展战略布局中的地位愈发凸显。当前，国家大力实施"两重""两新"政策，战略的全面实施为再生资源行业注入了强劲动能，带来新发展格局。
      </p>
      <p class="main-content">
        协会第七届理事会自2021年组建以来，高举习近平新时代中国特色社会主义思想伟大旗帜，在省社的关怀领导下，在省级有关部门支持指导下，紧紧围绕党中央国务院和省委省政府关于推动再生资源工作高质量发展的重点部署，团结广大会员，齐心协力，认真服务，踏实工作，充分发挥行业协会桥梁纽带、参谋助手作用。在政策研究、宣传推广、交流合作等方面做了很多有益工作，取得了一定成绩，进一步增强了协会的公信力和影响力。
      </p>
    </div>
    <bottom-url class="bottomUrl" />
  </div>
</template>

<script>
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';
export default {
  components: {
    BottomUrl,
  },
  methods: {
    goToJoin() {
      if (this.$store.state.ordinaryLoggedIn) {
        this.$router.push('/Home/aboutUs/joinAssociation');
      } else {
        this.$message.error('请先登录！');
      }
    }
  }
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
  .header {
    width: 100% !important;
    height: 120px  !important;
    //line-height: 100px  !important;
  }
  .main {
    width: 100% !important;
    padding: 10px !important;
  }
  .join-association-btn{
    width: unset !important;
    height: 20px !important;
  }
  .main-title {
    font-size: 16px !important;
  }
  .main-content {
    font-size: 14px !important;
  }
  .main-bg {
    img {
      width:50% !important;
      height: auto !important;
    }
  }
  .join-association-btn {
    width: 80px !important;
    height: 25px !important;
    font-size: 14px !important;
  }
}
.about-us {
  font-family: 微软雅黑;
  width: 100%;

  .header {
    width: 100%;
    height: 280px;
    line-height: 240px;
    text-align: center;
    background: url('~@/assets/recycling/index/association-bg.png') center/cover no-repeat;
    color: #ffffff;
    font-size: 36px;
    font-weight: 400;
    letter-spacing: 12px;
  }

  .main {
    width: 1080px;
    margin: 50px auto 84px;
    text-align: center;

    .title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .join-association-btn {
      width: 150px;
      height: 40px;
      padding: 0 20px;
      background-color: #43cf7c;
      border-color: #43cf7c;
      color: white;
      font-size: 16px;
      border-radius: 20px;

      &:hover {
        background-color: #35b06a;
        border-color: #35b06a;
      }
    }

    .main-title {
      color: rgb(34, 34, 34);
      font-size: 30px;
      font-weight: 700;
      letter-spacing: 4px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0;
      flex: 1;

      &::before,
      &::after {
        content: '';
        width: 300px;
        height: 1px;
        background: rgb(221, 221, 221);
        margin: 0 15px;
      }
    }

    .main-content {
      margin-top: 44px;
      color: rgb(77, 81, 90);
      font-size: 20px;
      font-weight: 400;
      line-height: 150%;
      letter-spacing: 0px;
      text-align: left;
      text-indent: 2em;
    }
  }
}

.bottomUrl {
  margin-top: 60px;
}
</style>
